export const NonBreakingSpace = () => <>&nbsp;</>;
